import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  scrollWrapper: {
    overflowX: 'auto',
  },
  endOfList: {
    textAlign: 'center',
    padding: '1rem',
    color: '#888',
    fontSize: '0.875rem',
  },
})

export default useStyles
